export class SimpleEmitter {
    constructor() {
        this.listeners = [];
    }
    listen(listener) {
        this.listeners.push(listener);
    }
    stop(listener) {
        this.listeners = this.listeners.filter(l => l !== listener);
    }
    emit(arg) {
        for (const listener of this.listeners) {
            listener(arg);
        }
    }
    reset() {
        this.listeners = [];
    }
}
